import "./styles.css";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner" />
      <span className="loading-text">Carregando...</span>
    </div>
  );
};

export default Loading;
